<template>
  <div id="pageRoot" class="blind">

    <img
    style="width: 130px; top: 150px; left: 80px"
    class="pageElement basicItem01"
    src="/pages/img/sordo/svgPage65Ball.svg"
    />

    <p class="textBase" style="top: 300px; left: 80px;">PELOTA</p>

    <label
      class="checkMarkContainer-blind"
      style="left: 294px; top: 250px; font-size: 0px"
      >Una Sílaba
      <input type="checkbox"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 357px; top: 250px; font-size: 0px"
      >Dos Sílabas
      <input type="checkbox"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 421px; top: 250px; font-size: 0px"
      >Tres Sílabas
      <input type="checkbox"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 483px; top: 250px; font-size: 0px"
      >Cuatro Sílabas
      <input type="checkbox"
      disabled 
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 546px; top: 250px; font-size: 0px"
      >Cinco Sílabas
      <input type="checkbox"
      disabled 
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 610px; top: 250px; font-size: 0px"
      >Seis Sílabas
      <input type="checkbox"
      disabled 
        />
      <span class="checkmark-blind"></span>
    </label>

    <div style="width: 230px; height: 200px; top: 200px; left: 730px; position: absolute;">
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="0"
      id="inputField01"
      class="centerH"
      style="position: absolute;
      width: 160px;
      height: 50px;
      top: 50px;
      z-index: 2"
    />
    <img
    style="width: 100%; z-index: -1"
    class="pageElement"
    src="/pages/img/general/blindNote.svg"
    />
    </div>

    <img
    style="width: 210px; top: 450px; left: 40px"
    class="pageElement basicItem01"
    src="/pages/img/sordo/svgPage64Roof.svg"
    />

    <p class="textBase" style="top: 620px; left: 90px;">TECHO</p>

    <label
      class="checkMarkContainer-blind"
      style="left: 294px; top: 500px; font-size: 0px"
      >Una Sílaba
      <input type="checkbox"
        ref="b1" 
        v-on:change="saveOption('radios', 'b1')" 
        :onload="loadOption('radios', 'b1')"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 357px; top: 500px; font-size: 0px"
      >Dos Sílabas
      <input type="checkbox"
        ref="b2" 
        v-on:change="saveOption('radios', 'b2')" 
        :onload="loadOption('radios', 'b2')"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 421px; top: 500px; font-size: 0px"
      >Tres Sílabas
      <input type="checkbox"
        ref="b3" 
        v-on:change="saveOption('radios', 'b3')" 
        :onload="loadOption('radios', 'b3')"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 483px; top: 500px; font-size: 0px"
      >Cuatro Sílabas
      <input type="checkbox"
        ref="b4" 
        v-on:change="saveOption('radios', 'b4')" 
        :onload="loadOption('radios', 'b4')"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 546px; top: 500px; font-size: 0px"
      >Cinco Sílabas
      <input type="checkbox"
        ref="b5" 
        v-on:change="saveOption('radios', 'b5')" 
        :onload="loadOption('radios', 'b5')"
        />
      <span class="checkmark-blind"></span>
    </label>
    <label
      class="checkMarkContainer-blind"
      style="left: 610px; top: 500px; font-size: 0px"
      >Seis Sílabas
      <input type="checkbox"
        ref="b6" 
        v-on:change="saveOption('radios', 'b6')" 
        :onload="loadOption('radios', 'b6')"
        />
      <span class="checkmark-blind"></span>
    </label>

  <div style="width: 230px; height: 200px; top: 430px; left: 730px; position: absolute;">
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="centerH"
      style="position: absolute;
      width: 160px;
      height: 50px;
      top: 50px;
      z-index: 2"
    />
    <img
    style="width: 100%; z-index: -1"
    class="pageElement"
    src="/pages/img/general/blindNote.svg"
    />
  </div>
    
  </div>
</template>
<script>
  export default {
    methods:{
      dbId(name, option){
        return `${this.$parent.pageID()}-${name}-${option}`
      },
      async loadOption(name, option) {
        var id = this.dbId(name, option);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[option].checked=value.option;

        console.log("option loaded: " + id + ", " + value.option);
      },
      saveOption(name, option) {
        var id = this.dbId(name, option);
        var value = this.$refs[option].checked;

        this.$db.options.put({
              id: id,
              option: value
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + value);
      }
    },
    mounted(){

    }
  }
</script>